import { render, staticRenderFns } from "./modal_file_vetus.vue?vue&type=template&id=bd3dc65e&scoped=true&"
import script from "./modal_file_vetus.vue?vue&type=script&lang=js&"
export * from "./modal_file_vetus.vue?vue&type=script&lang=js&"
import style0 from "./modal_file_vetus.vue?vue&type=style&index=0&id=bd3dc65e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3dc65e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDataTable,VIcon})
